<template>
  <div class="row">
    <div class="col-12">
      <code v-if="debug">
        {{ data }}
        <hr />
        {{ model }}
      </code>
      <div>
        <b-form-group label="Airline Code" :disabled="false">
          <b-form-input
            :state="airlineCodeValid"
            v-model="model.AirlineCode"
            :maxlength="3"
            class="col-2 uc"
          ></b-form-input>
        </b-form-group>
      </div>

      <div>
        <b-form-group label="Airline Group" :disabled="false">
          <v-select
            v-model="model.AirlineGroupId"
            :options="AirlineGroup"
            :reduce="(e) => e.MenuAirlineGroupId"
            label="AirlineIcaoCode"
          >
          </v-select>
        </b-form-group>
      </div>

      <div>
        <b-form-group label="Check-In Enabled" :disabled="false">
          <div class="toggleWrapper">
            <input
              id="checkinEnabled"
              v-model="boolsSwitches.CheckInEnabled"
              class="dn"
              type="checkbox"
            />
            <label class="toggle" for="checkinEnabled"
              ><span class="toggle__handler"></span
            ></label>
          </div>
        </b-form-group>
      </div>

      <div>
        <b-form-group label="Bagtag Printing Enabled" :disabled="false">
          <div class="toggleWrapper">
            <input
              id="bagtagPrintingEnabled"
              v-model="boolsSwitches.BagTagPrintingEnabled"
              class="dn"
              type="checkbox"
            />
            <label class="toggle" for="bagtagPrintingEnabled"
              ><span class="toggle__handler"></span
            ></label>
          </div>
        </b-form-group>
      </div>

      <div>
        <b-form-group label="Max Group Size" :disabled="false">
          <b-form-input
            v-model="model.MaxGroupSize"
            :state="
              model.MaxGroupSize &&
                model.MaxGroupSize < 10 &&
                model.MaxGroupSize > 0
            "
            type="number"
            :min="1"
            :max="9"
            class="col-2"
          ></b-form-input>
        </b-form-group>
      </div>
    </div>
    <hr />
    <div class="col-12 bt-1">
      <b-button variant="success" class="mr-1" @click="save">Save</b-button>
      <b-button variant="success" @click="saveAndClose"
        >Save &amp; Close</b-button
      >
      <b-button variant="secondary" class="ml-1" @click="cancel"
        >Cancel</b-button
      >
    </div>
  </div>
</template>

<script>
import NotificationMixin from '@mixins/notificationMixin.js'
import CancelMixin from '@mixins/cancel.js'
export default {
  mixins: [NotificationMixin, CancelMixin],
  props: {
    data: {
      type: Object,
      required: true,
    },
    contentType: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      debug: false,
      boolsSwitches: {
        CheckInEnabled: false,
        BagTagPrintingEnabled: false,
      },
      model: {
        AirlineId: null,
        AirlineCode: null,
        AirlineGroupId: null,
        CheckInEnabled: null,
        BagTagPrintingEnabled: null,
        MaxGroupSize: 6,
      },
    }
  },
  watch: {
    data: {
      immediate: true,
      handler(data) {
        if (data) this.mapData(data)
      },
    },
    boolsSwitches: {
      deep: true,
      handler(bools) {
        // The server model uses T/F rather than bools!
        this.model.CheckInEnabled = bools.CheckInEnabled ? 'T' : 'F'
        this.model.BagTagPrintingEnabled = bools.BagTagPrintingEnabled
          ? 'T'
          : 'F'
      },
    },
  },
  computed: {
    airlineCodeValid() {
      return this.model.AirlineCode && this.model.AirlineCode.length > 1 && this.model.AirlineCode.length <= 3
    },
    AirlineGroup() {
      return this.$store.getters['AirlineGroup/list']
    },
    AirlineGroupLabel() {
      return this.AirlineGroup.find(
        (e) => e.MenuAirlineGroupId === this.model.AirlineGroupId
      )
    },
    saveEnabled() {
      return (
        this.model.MaxGroupSize &&
        this.model.MaxGroupSize < 10 &&
        this.model.MaxGroupSize > 0
      )
    },
  },
  beforeCreate() {
    // Get dependency data
    const depData = ['AirlineGroup']
    depData.forEach((key) => {
      this.$store.dispatch(`${key}/all`)
    })
  },
  methods: {
    mapData(dataIn) {
      //   Take the server data and apply it to our model
      this.model.AirlineId = dataIn.AirlineId
      this.model.AirlineCode = dataIn.AirlineCode
      this.model.AirlineGroupId = dataIn.AirlineGroupId
      this.model.CheckInEnabled = dataIn.CheckInEnabled
      this.model.BagTagPrintingEnabled = dataIn.BagTagPrintingEnabled
      this.model.MaxGroupSize = dataIn.MaxGroupSize

      // Switches
      this.boolsSwitches.CheckInEnabled = dataIn.CheckInEnabled === 'T'
      this.boolsSwitches.BagTagPrintingEnabled =
        dataIn.BagTagPrintingEnabled === 'T'
    },
    reduceFunc(e) {
      if (e & e.MenuAirlineGroupId) {
        return e.MenuAirlineGroupId
      }
    },
    async save() {
      if (!this.saveEnabled) {
        return
      }
      let id, type
      if (this.data) {
        id = this.data[this.contentType.idKey]
        type = 'patch'
      } else {
        id = 0
        type = 'post'
      }
      try {
        this.model.AirlineCode = this.model.AirlineCode.toUpperCase()
        await this.$store.dispatch(`${this.contentType.name}/${type}`, {
          id: id,
          body: this.model,
        })
        this.showNotification('Saved successfully', 'success')
      } catch (error) {
        this.showNotification(error, 'error')

        throw new Error(error)
      }
    },
    async saveAndClose() {
      if (!this.saveEnabled) {
        return
      }
      try {
        await this.save()
      } catch (error) {
        window.console.log(error)
        return
      }
      this.$router.push(`/${this.contentType.name}/list`)
    },
  },
}
</script>
